import { render, staticRenderFns } from "./EditRemotePlugin.vue?vue&type=template&id=2f2dc7cf&scoped=true&"
import script from "./EditRemotePlugin.vue?vue&type=script&lang=js&"
export * from "./EditRemotePlugin.vue?vue&type=script&lang=js&"
import style0 from "./EditRemotePlugin.vue?vue&type=style&index=0&id=2f2dc7cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2dc7cf",
  null
  
)

export default component.exports